import { AuthGuardSiteManagePlan } from '../AuthGuardSiteManagePlan';
import { DailyReportPage } from './DailyReportPage';

export const SiteManageAuthWrapperDailyReportPage: React.VFC = () => {
  return (
    <AuthGuardSiteManagePlan>
      <DailyReportPage />
    </AuthGuardSiteManagePlan>
  );
};
